import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

// Images
import SearchIcon from '../images/icons/magnifying-glass-solid-full.svg';
import FilterIcon from '../images/icons/filter-solid-full.svg';
import MenuIcon from '../images/icons/bars-solid-full.svg';
import CloseIcon from '../images/icons/x.svg';
import Logo from '../images/logo.png';

type Props = {
    title: string
    startSearch: (value: string) => void,
    saveSort: (sort: string) => void,
    saveDoc: (doc: string) => void,
    saveSeason: (season: number) => void,
    updateSearchValue: (search: string) => void,
    searchValue: string,
    sortFilter: string,
    seasonFilter: number,
    docFilter: string
}


export default function NavMenu({title, startSearch, saveSort, saveDoc, saveSeason, updateSearchValue, searchValue, sortFilter, seasonFilter, docFilter}: Props) {

    const navigate = useNavigate();
    const scrollDirection = useScrollDirection();

    // const [displayMenu, setDisplayMenu] = useState<boolean>(false);

    // Filter Values
    const [displayFilters, setDisplayFilters] = useState<boolean>(false);
    const [searchFocus, setSearchFocus] = useState<boolean>(false);


    const released = [
        "Destiny", "The Dark Below", "House of Wolves", "The Taken King", "Rise of Iron", "Age of Triumph",
        "Destiny 2", "Curse of Osiris", "Warmind",
        "Forsaken", "Season of the Forge", "Season of the Drifter", "Season of Opulence",
        "Shadowkeep", "Season of the Undying", "Season of Dawn", "Season of the Worthy", "Season of Arrivals", 
        "Beyond Light", "Season of the Hunt", "Season of the Chosen", "Season of the Splicer", "Season of the Lost",
        "Witch Queen", "Season of the Risen", "Season of the Haunted", "Season of Plunder", "Season of the Seraph",
        "Lightfall", "Season of Defiance", "Season of the Deep", "Season of the Witch", "Season of the Wish",
        "Final Shape", "Episode Echoes", "Episode Revenant", "Episode Heresy",
        "Edge of Fate", "Renegades", "Monument of Triumph"
    ];


    useEffect(() => {
        if(scrollDirection === "down") {
            setDisplayFilters(false);
        }
    }, [scrollDirection]);

    return(
        <div className={`top-header ${scrollDirection === "down" ? "down" : "up"}`}>

            <div className="menu-container">
                <div
                    className="menu"
                    onClick={() => {navigate("/")}}
                >
                    <img src={Logo} />
                </div>

                <h3> {title} </h3>
            </div>

            {/* <div className={`menu-display ${displayMenu? "open" : "close"}`}>
                <div className="top-section">
                    <div className="logo border" onClick={() => {navigate("/")}}><img src={Logo} /></div>
                    <div className="close" onClick={() => {setDisplayMenu(false)}}><img src={CloseIcon} /></div>
                </div>

                <div>
                    <div>Home</div>
                    <div>Seasons</div>
                    <div>Lore</div>
                    <div>Items</div>
                    <div>Quests</div>
                    <div>About</div>
                </div>
                
            </div> */}
            
            <div className="search header">
                <input
                    type="text"
                    placeholder={'Search'}
                    value={searchValue}
                    onChange={(e) => {updateSearchValue(e.target.value)}}
                    onBlur={() => { setSearchFocus(false)}}
                    onFocus={() => { setSearchFocus(true)}}
                    onKeyDown={(e) => {startSearch(e.key)}}
                />
                <div className={`search-icon grey ${searchFocus}`}>
                    <img src={SearchIcon} alt="search-icon" />
                </div>
            </div>

            <div className="filter-container">
                <div className={`filters-button grey ${displayFilters ? "active" : ""}`} onClick={() => {setDisplayFilters(!displayFilters)}}>
                    <img src={FilterIcon} /> 
                    {!displayFilters && <span>Filters</span>}
                    {displayFilters && <span>Close</span>}
                </div>
            </div>

            <div className={`filters-display ${displayFilters ? "open" : "close"}`}>

                <div className="sort-filter">
                    <h3>Sort By</h3>                                
                    <select
                        value={sortFilter}
                        onChange={(e) => {saveSort(e.target.value)}}
                    >
                        <option value={"alphabetical-asc"}>A → Z</option>
                        <option value={"alphabetical-desc"}>Z → A</option>
                        <option value={"released-asc"}>Season (Newest - Oldest)</option>
                        <option value={"released-desc"}>Season (Oldest - Newest)</option>
                    </select>
                </div>

                <div className="doc-filter">
                    <h3>Lore Type</h3>
                    <select
                        value={docFilter}
                        onChange={(e) => {saveDoc(e.target.value)}}
                    >
                        <option value={"All"}>All</option>
                        <option value={"Lore Entry"}>Lore Entry</option>
                        <option value={"Lore Book"}>Lore Book</option>
                        <option value={"Grimoire"}>Grimoire</option>
                        <option value={"Item"}>Item</option>
                    </select>
                </div>
                
                <div className="season-filter">
                    <h3>Season</h3>
                    <select
                        value={seasonFilter}
                        onChange={(e) => {saveSeason(Number(e.target.value))}}
                    >
                        <option value={-1}>All</option>
                        {released.map((entry: string, index: number) => {
                            return(
                                <option
                                    key={index}
                                    value={index}
                                    id={entry}
                                >
                                    {entry}
                                </option>
                            );
                        })}
                    </select>
                </div>

            </div>
            
        </div>
    );
}

function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState<string | null>(null);

  useEffect(() => {
    let lastScrollY = window.pageYOffset;

    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      const direction = scrollY > lastScrollY ? "down" : "up";
      if (direction !== scrollDirection && (scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)) {
        setScrollDirection(direction);
      }
      lastScrollY = scrollY > 0 ? scrollY : 0;
    };
    window.addEventListener("scroll", updateScrollDirection); // add event listener
    return () => {
      window.removeEventListener("scroll", updateScrollDirection); // clean up
    }
  }, [scrollDirection]);

  return scrollDirection;
};